import { newProductSnapshot, Product, ProductSnapshot, ProductSubType, ProductType, saledPrice } from '../shared-lib/domains/product';
import { Discount, FeeType, FullPrice, Price } from '../shared-lib/global/models';
import { uidI } from '../shared/utils/utils';

export class ShoppingCart {
  createdAt: Date;
  updatedAt: Date;
  userId?: string; // reference to user document. may be anonymous
  items: ShoppingCart.OrderItem[];
  shipping: {
    weight: number;
    price: Price; //Precio que se cobra d eenvío
    fullPrice?: Price; //Precio full sin considerar el desceunto
  };
  price: FullPrice; // total to pay
  discounts: Array<Discount>;
}

export namespace ShoppingCart {

  export interface OrderItemUi extends OrderItem {
    _files?: any[];
  }

  export class OrderItem {
    cartId: string;
    notEditable?: boolean; //Si no se puede editar
    product: ProductSnapshot; // reference to Product
    qty: number; // quantity: total amount of this item (print producs: duplicates)
    price: Price; // item price: qty * product.unitPrice
    payload?: {
      fee: {
        userId: string;
        type: FeeType;
      };
    };
    unavailable?: boolean;
    taxReduced?: boolean;
  }

  export const newOrderItem = (product: Product, qty: number, oldData?): OrderItem => {
    const _product = newProductSnapshot(product as any);
    const cartId = uidI();
    _product.unitPrice = (product as any)['price'] ?? saledPrice(product.subType === ProductSubType.CUSTOM && oldData ? oldData : product);
    _product.categories = product.categories ?? null;
    const price = { ...saledPrice(product.subType === ProductSubType.CUSTOM && oldData ? oldData : product) };
    const extraPrice = product.extra?.price ?? 0;
    const royalty = (product as any).royalty ?? 0;
    price.amt = (qty * (extraPrice + price.amt)) + royalty;
    if (!_product.type) {
      _product.type = ProductType.STORE;
    }
    if (oldData) {
      _product.title = oldData.title;
      _product.categories = oldData.categories;
      if (product.subType === ProductSubType.CUSTOM) {
        _product.customElementsSelected = oldData?.customElementsSelected;
      }
    }
    return { cartId, product: _product, qty, price };
  };

}

